// src/theme/bbfTheme.js
import { createTheme } from '@mui/material/styles';

const bbfTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#283593' },      // Deep indigo (trustworthy)
    secondary: { main: '#00bcd4' },    // AI teal accent
    background: { default: '#f9fafc', paper: '#ffffff' },
    info: { main: '#0288d1' },         // Electric blue
    success: { main: '#388e3c' },      // Vermont green
  },
  typography: {
    fontFamily: ['Inter', 'Roboto', 'Arial', 'sans-serif'].join(','),
    h1: { fontWeight: 700, letterSpacing: '-0.5px' },
    h2: { fontWeight: 600 },
    h6: { fontWeight: 500, color: '#283593' },
    body1: { fontSize: '0.95rem', lineHeight: 1.6 },
    body2: { fontSize: '0.85rem', color: '#555' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
          transition: 'box-shadow 120ms ease',
          '&:hover': {
            boxShadow: '0 0 10px rgba(0, 188, 212, 0.3)', // subtle AI glow
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
        },
      },
    },
  },
});

export default bbfTheme;
